import {useDebugValue} from 'react';

import {
    useGuestsActions,
    useGuestsEvents,
    useGuestsOptions,
    useGuestsSelectors,
    useGuestsSettings,
    useGuestsTranslations,
    useGuestsValues
} from './';

function useGuests(props, cookies, system, abacus) {
    const {
        events
    } = useGuestsEvents(props);

    const {
        options
    } = useGuestsOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useGuestsSettings(props);

    const {
        translations
    } = useGuestsTranslations(props);

    const {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useGuestsValues(props, cookies, system, abacus);

    const actions = useGuestsActions({
        events,
        options,
        initialSettings,
        settings,
        changeSettings,
        translations,
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    });

    const selectors = useGuestsSelectors({
        options,
        settings,
        translations,
        currentValues,
        latestValues
    });

    const result = {
        actions,
        events,
        options,
        selectors,
        settings,
        translations,
        currentValues,
        latestValues
    };

    useDebugValue(result);

    return result;
}

export {useGuests};
